export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15135.c7a4a803.jpg";